module.exports = __webpack_public_path__ + "static/sandro_pinheiro-713f0f0542d8f267d3232e23af9fce9d.png";